import { useState } from "react";
import { createPortal } from "react-dom";

export default function CalendarPickerModal({ calendars, selected, onApply, onClose }) {
  const [checked, setChecked] = useState(selected || calendars.filter(c => c.primary).map(c => c.id));

  const toggle = (id) => {
    setChecked(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  return createPortal(
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 200 }}>
      <div style={{ background: "#0f1923", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 20, padding: 36, width: 460, maxWidth: "90vw" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h2 style={{ fontFamily: "'Playfair Display',serif", color: "#f0ede8", margin: 0, fontSize: 20 }}>📅 Select Calendars</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.4)", cursor: "pointer", fontSize: 20 }}>×</button>
        </div>
        <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 12, marginBottom: 20 }}>Choose which calendars to pull appointments from.</p>
        <div style={{ maxHeight: 320, overflowY: "auto", marginBottom: 20 }}>
          {calendars.map(cal => (
            <div key={cal.id} onClick={() => toggle(cal.id)}
              style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", borderRadius: 10, cursor: "pointer", marginBottom: 4, background: checked.includes(cal.id) ? "rgba(255,255,255,0.06)" : "transparent", border: `1px solid ${checked.includes(cal.id) ? "rgba(255,255,255,0.12)" : "transparent"}` }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.06)"}
              onMouseLeave={e => e.currentTarget.style.background = checked.includes(cal.id) ? "rgba(255,255,255,0.06)" : "transparent"}
            >
              <div style={{ width: 14, height: 14, borderRadius: 3, background: checked.includes(cal.id) ? cal.color : "transparent", border: `2px solid ${cal.color}`, flexShrink: 0, transition: "background 0.15s" }} />
              <div style={{ flex: 1 }}>
                <div style={{ color: "#f0ede8", fontSize: 13 }}>{cal.name}</div>
                {cal.primary && <div style={{ color: "rgba(255,255,255,0.3)", fontSize: 10 }}>Primary calendar</div>}
              </div>
              {checked.includes(cal.id) && <span style={{ color: "#4ade80", fontSize: 14 }}>✓</span>}
            </div>
          ))}
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, padding: "12px", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 10, color: "rgba(255,255,255,0.6)", cursor: "pointer" }}>Cancel</button>
          <button
            onClick={() => { if (checked.length > 0) { onApply(checked); onClose(); } }}
            disabled={checked.length === 0}
            style={{ flex: 2, padding: "12px", background: checked.length > 0 ? "rgba(99,102,241,0.8)" : "rgba(99,102,241,0.3)", border: "none", borderRadius: 10, color: "#fff", cursor: checked.length > 0 ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600 }}>
            Load {checked.length} Calendar{checked.length !== 1 ? "s" : ""}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
